import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonLibraryLifecycleOverview, CommonLibraryLifecycleTopics } from "../../CommonComponents/CommonLibraryLifecycleViews";

export const LibraryLifecyclesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.lifecycles,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryLifecycleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryLifecycleTopics />;
    },
};
